// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { LoggedInUser } from '../'

// import {
//   getIdentityResponsibility,
//   encodeBase64
// } from '../../utils'

import logo_icon from '../../assets/img/MessagePlus_logo.png'
import './header.css'


export const GlobalHeader = ({ accountId, isEmployerGroupAccount, navigationLinks, searchValue, onSearchClick, onSearchChange, onSearchClear, onUserClick, hideSearch, className }) => {
  // let identityResponsibility = getIdentityResponsibility("Read Employer")
  return (
    <header className={`header slds-size_1-of-1 ${className}`} role="banner">
      <div className='slds-grid slds-size_1-of-1' style={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <div className='slds-grid' style={{ alignItems: 'center' }}>
          <div className='slds-m-right_x-small'>
            <img src={logo_icon} alt="Picsa Logo" style={{ height: '80px' }} />
          </div>
          <div className="slds-p-top_xx-small">
            <nav>
              <ul role="tablist">
                {navigationLinks}
              </ul>
            </nav>
          </div>
        </div>
        <LoggedInUser
          // employerId={identityResponsibility && identityResponsibility.length > 0
          //   ? encodeBase64(identityResponsibility.node.relatedId, "EmployerNode")
          //   : null
          // }
          accountId={accountId}
          isEmployerGroupAccount={isEmployerGroupAccount}
          onClick={onUserClick}
          className="slds-m-top_x-small"
        />
      </div>
    </header>
  )
}

GlobalHeader.propTypes = {
  accountId: PropTypes.string.isRequired,
  isEmployerGroupAccount: PropTypes.bool,
  navigationLinks: PropTypes.arrayOf(PropTypes.element).isRequired,  // expects an array of <li> elements
  onUserClick: PropTypes.func,
  className: PropTypes.string
}

GlobalHeader.defaultProps = {
  hideSearch: false
}



// WEBPACK FOOTER //
// ./src/components/global-header/index.js